import React from 'react';
import { motion } from 'framer-motion';
import { Phone, Clock, Shield } from 'lucide-react';

export function EmergencySectionModern() {
  return (
    <section className="py-20 bg-red-600">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          {/* Main Content */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="mb-12"
          >
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Intervention d'Urgence
            </h2>
            <p className="text-xl text-red-100 mb-8 max-w-3xl mx-auto">
              Fuite d'eau, canalisation bouchée, panne de chauffage ? 
              Notre équipe intervient rapidement 24h/24 partout en Belgique.
            </p>
          </motion.div>

          {/* Phone Number */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            viewport={{ once: true }}
            className="mb-12"
          >
            <div className="bg-white rounded-2xl p-8 shadow-2xl inline-block">
              <div className="flex items-center justify-center gap-4 mb-4">
                <div className="w-12 h-12 bg-red-100 rounded-xl flex items-center justify-center">
                  <Phone className="w-6 h-6 text-red-600" />
                </div>
                <div className="text-left">
                  <p className="text-sm text-gray-600">Appelez maintenant</p>
                  <h3 className="text-3xl md:text-4xl font-bold text-gray-900">
                    0465 19 57 26
                  </h3>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Features */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
            className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12"
          >
            <div className="flex items-center justify-center gap-3 text-white">
              <Clock className="w-6 h-6 text-red-200" />
              <span className="text-lg font-medium">Intervention sous 2h</span>
            </div>
            <div className="flex items-center justify-center gap-3 text-white">
              <Shield className="w-6 h-6 text-red-200" />
              <span className="text-lg font-medium">Service 24h/24 - 7j/7</span>
            </div>
            <div className="flex items-center justify-center gap-3 text-white">
              <Phone className="w-6 h-6 text-red-200" />
              <span className="text-lg font-medium">Toute la Belgique</span>
            </div>
          </motion.div>

          {/* CTA Button */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            viewport={{ once: true }}
          >
            <button
              onClick={() => window.open('tel:+32465195726')}
              className="bg-white hover:bg-gray-100 text-red-600 px-8 py-4 rounded-xl font-semibold text-lg shadow-xl transition-all duration-200 hover:scale-105"
            >
              Appeler Maintenant
            </button>
          </motion.div>
        </div>
      </div>
    </section>
  );
}